// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 538 ? "recorder" : chunkId) + "-legacy." + {"437":"1055f7c4","538":"d3555b05","554":"d00a39b4"}[chunkId] + ".js";
};